import { markRaw } from 'vue'
import type { PageState } from '@/types/ainotebook'
import { fillWhite } from '@/utils/ainotebook/draw'

export function usePageRenderer(
  pdfDocRef: { value: any },
  pagesRef: { value: PageState[] }
) {
  let renderToken = 0

  async function renderThumb(pageNumber: number, thumbScale = 0.25) {
    const token = ++renderToken
    const pdfDoc = pdfDocRef.value
    if (!pdfDoc) return

    const p = pagesRef.value.find(x => x.pageNumber === pageNumber)
    if (!p || p.thumbUrl) return

    const page = markRaw(await pdfDoc.getPage(pageNumber))
    if (token !== renderToken) return

    const v = page.getViewport({ scale: thumbScale })
    const c = document.createElement('canvas')
    c.width = Math.floor(v.width)
    c.height = Math.floor(v.height)
    const ctx = c.getContext('2d')!
    fillWhite(ctx, c.width, c.height)
    await page.render({ canvasContext: ctx, viewport: v }).promise
    if (token !== renderToken) return

    p.thumbUrl = c.toDataURL('image/jpeg', 0.85)
  }

  async function renderMain(pageNumber: number, scale = 2.0, force = false) {
    const token = ++renderToken
    const pdfDoc = pdfDocRef.value
    if (!pdfDoc) return

    const p = pagesRef.value.find(x => x.pageNumber === pageNumber)
    if (!p) return

    // ✅ 有快取且不強制 -> 直接用
    if (!force && p.pageUrl) return

    // ✅ 強制時要先清掉舊 url，避免 component/瀏覽器拿舊資源
    if (force) p.pageUrl = ''

    const page = markRaw(await pdfDoc.getPage(pageNumber))
    if (token !== renderToken) return

    const v = page.getViewport({ scale })
    const c = document.createElement('canvas')
    c.width = Math.floor(v.width)
    c.height = Math.floor(v.height)
    const ctx = c.getContext('2d')!
    fillWhite(ctx, c.width, c.height)
    await page.render({ canvasContext: ctx, viewport: v }).promise
    if (token !== renderToken) return

    p.pageUrl = c.toDataURL('image/jpeg', 0.9)
    p.width = c.width
    p.height = c.height
  }

  function cancelAllRenders() {
    renderToken++
  }

  return { renderThumb, renderMain, cancelAllRenders }
}
